@use "../../styles/breakpoint.module.scss" as *;

.curtains {
    --curtains: var(--spacer-24);

    clip-path: inset(var(--curtains));
}

.overlay::after {
    content: "";
    display: inline-block;
    background: var(--linear-from-bottom);
    position: absolute;
    inset: 0;
}

.content {
    --filled-button-text: var(--beige);

    margin-block: var(--spacer-64);

    & :global(.buttonFilled) {
        background: var(--color-primary);
    }

    & :is(h1, h2, h3, h4, h5, h6, .eyebrow) {
        text-shadow: 0 0 1em var(--midnight);
    }
}

.contentInCarousel {
    composes: content;
    margin-bottom: var(--spacer-80);
}
